import { Component, OnInit } from '@angular/core';
import { SessionService } from '@app/services/session.service';
import { Field } from '@app/_models/facilities';

@Component({
  selector: 'app-mod-canchas',
  templateUrl: './mod-canchas.component.html',
  styleUrls: ['./mod-canchas.component.scss']
})
export class ModCanchasComponent implements OnInit {
  canchas: Field[];
  displayedColumns: string[] = ['Nombre', 'Size', 'TipoTurno', 'More'];

  constructor(
    private session: SessionService
  ) { }

  ngOnInit() {
    this.canchas = this.session.canchas;
  }

}
